var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "232 -824 496 703.38",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232-225.23v-32h32.62v-276.92q0-82.39 53.11-143.39 53.12-61 134.27-71.61V-796q0-11.67 8.14-19.83 8.14-8.17 19.77-8.17t19.86 8.17Q508-807.67 508-796v46.85q81.15 10.61 134.27 71.61 53.11 61 53.11 143.39v276.92H728v32zm247.65 104.61q-23.5 0-39.88-16.63-16.39-16.63-16.39-39.98h113.24q0 23.85-16.74 40.23-16.73 16.38-40.23 16.38M296.62-257.23h366.76v-276.92q0-76.93-53.23-130.16T480-717.54t-130.15 53.23-53.23 130.16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.301eadb1358c987d99768e5dc617931b.svg";
export { ForwardRef as ReactComponent };